export enum ApproveStepAction {
  Immediately = 'immediately',
  Choose = 'choose',
}

export interface ApproveStepFormValues {
  action: ApproveStepAction
  effectiveAt: string | null
  expiresAt: string | null
}
